import { get } from 'lodash-es'
import { types as STORE_MODULES } from '@/js/plugins/store/store-modules'
import APP_CONSTANTS from '@/js/plugins/store/modules/app/constants.js'
import AIMEOS_ACTIONS from '@/js/plugins/store/modules/aimeos/actions/actions-types'
import APP_ACTIONS from '@/js/plugins/store/modules/app/action-types'

const loggedInStartRequests = async store => {
  await store.dispatch(`${STORE_MODULES.AIMEOS}/${AIMEOS_ACTIONS.GET_CUSTOMER}`)
  await store.dispatch(`${STORE_MODULES.AIMEOS}/${AIMEOS_ACTIONS.GET_BLOCKINGREASONS}`)
  await store.dispatch(`${STORE_MODULES.APP}/${APP_ACTIONS.GET_NEWS_UNREAD}`)
  // eslint-disable-next-line spaced-comment
/////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////
////////////
}

export default store => {
  const isLoggedIn = !!get(store, [
    'state',
    STORE_MODULES.APP,
    APP_CONSTANTS.APP_CONFIG,
    APP_CONSTANTS.USER,
    APP_CONSTANTS.USERNAME,
  ])

  const pollingInterval =
    get(store, ['state', STORE_MODULES.APP, APP_CONSTANTS.POLLING_INTERVAL_MINUTES]) ?? 0

  if (isLoggedIn) {
    loggedInStartRequests(store)

    // Init polling if user is logged in and Interval is set
    if (pollingInterval > 0) {
      setInterval(async () => {
        // Dispatch Blockingreasons request each interval
        await store.dispatch(`${STORE_MODULES.AIMEOS}/${AIMEOS_ACTIONS.GET_BLOCKINGREASONS}`)
        await store.dispatch(`${STORE_MODULES.APP}/${APP_ACTIONS.GET_NEWS_UNREAD}`)
      }, 1000 * 60 * pollingInterval)
    }
  }
}
